import { render, staticRenderFns } from "./IncidenceList.vue?vue&type=template&id=6ff2c6d2"
import script from "./IncidenceList.vue?vue&type=script&lang=js"
export * from "./IncidenceList.vue?vue&type=script&lang=js"
import style0 from "./IncidenceList.vue?vue&type=style&index=0&id=6ff2c6d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports